/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TranscribeAudioResponseDto,
} from '../models/index';
import {
    TranscribeAudioResponseDtoFromJSON,
    TranscribeAudioResponseDtoToJSON,
} from '../models/index';

export interface AudioControllerTranscribeAudioRequest {
    audio: Blob;
}

/**
 * AudioApi - interface
 * 
 * @export
 * @interface AudioApiInterface
 */
export interface AudioApiInterface {
    /**
     * Accepts a short voice recording (webm or mp4) and returns its transcribed text, for use as a chat message.
     * @summary Transcribe a recorded audio clip to text
     * @param {Blob} audio The recorded audio clip. Up to a few minutes; webm or mp4.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudioApiInterface
     */
    audioControllerTranscribeAudioRaw(requestParameters: AudioControllerTranscribeAudioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscribeAudioResponseDto>>;

    /**
     * Accepts a short voice recording (webm or mp4) and returns its transcribed text, for use as a chat message.
     * Transcribe a recorded audio clip to text
     */
    audioControllerTranscribeAudio(requestParameters: AudioControllerTranscribeAudioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscribeAudioResponseDto>;

}

/**
 * 
 */
export class AudioApi extends runtime.BaseAPI implements AudioApiInterface {

    /**
     * Accepts a short voice recording (webm or mp4) and returns its transcribed text, for use as a chat message.
     * Transcribe a recorded audio clip to text
     */
    async audioControllerTranscribeAudioRaw(requestParameters: AudioControllerTranscribeAudioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscribeAudioResponseDto>> {
        if (requestParameters['audio'] == null) {
            throw new runtime.RequiredError(
                'audio',
                'Required parameter "audio" was null or undefined when calling audioControllerTranscribeAudio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['audio'] != null) {
            formParams.append('audio', requestParameters['audio'] as any);
        }


        let urlPath = `/audio/transcriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranscribeAudioResponseDtoFromJSON(jsonValue));
    }

    /**
     * Accepts a short voice recording (webm or mp4) and returns its transcribed text, for use as a chat message.
     * Transcribe a recorded audio clip to text
     */
    async audioControllerTranscribeAudio(requestParameters: AudioControllerTranscribeAudioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscribeAudioResponseDto> {
        const response = await this.audioControllerTranscribeAudioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
